export default "__VITE_ASSET__BC48VKO3__"